import { scheduleSuborderOnTransporterOrderRequest,scheduleSuborderOnTripRequest } from '../../requests';
export default async function scheduleTransporterOrderEdi({ dispatch }, obj) {
	if (obj.type === 'external')
		await scheduleSuborderOnTransporterOrderRequest(obj.id, obj.subOrderId);
	else
		await scheduleSuborderOnTripRequest(obj.id, obj.subOrderId);
	dispatch('tripSearch/fetchTrips');
}